export { default as numberFunc } from './number-func'
export { default as dateFunc } from './date-func'
export { default as colorFunc } from './color-func'